import type { CityListItem } from './types';

/**
 * 按 mapId 在多个城市列表中依次查找，参数顺序即匹配优先级。
 * 例如先查 myCityMapList（含会员字段）再查 cityList（全量字典）。
 */
export const findCityByMapId = (mapId: string | number | null | undefined, ...cityLists: CityListItem[][]): CityListItem | null => {
    if (mapId == null || mapId === '') return null;
    const id = String(mapId);

    for (const cityList of cityLists) {
        const matched = cityList.find(city => String(city.mapId) === id);
        if (matched) return matched;
    }
    return null;
};
